import React from 'react'
import { useStateValue } from '@State'
import { AchievementGroup } from './AchievementGroup'

export const AchievementGroups = () => {
  let [currentState] = useStateValue()
  return (
    <div className="d-flex w-100">
      <div className="w-50">
        <AchievementGroup title="Badges" achievements={currentState.badges} />
      </div>
      <div className="w-50">
        <AchievementGroup
          title="Certificates"
          achievements={currentState.certificates}
        />
      </div>
    </div>
  )
}
